import { useMutation } from '@tanstack/react-query';

import { AllowedTimeFormSchemaValues } from 'src/features/allowedTimes/utils/formSchema';
import { AllowedTimes } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralSmartParkError } from 'src/registry/types/axios';

const RESOURCE = 'sp-core/:parkingId/memberships/membership-type/:membershipTypeId/allowed-times/:allowedTimeId/';

interface DTO extends AllowedTimeFormSchemaValues {
    membershipTypeId: string;
    allowedTimeId: string;
    parkingId: string;
}
const mutationFn = ({ membershipTypeId, allowedTimeId, parkingId, ...data }: DTO): Promise<AllowedTimes> => {
    return axios.put(formatResourcePath(RESOURCE, { membershipTypeId, allowedTimeId, parkingId }), data);
};

type MutationFnType = typeof mutationFn;

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as UPDATE_MEMBERSHIP_TYPE_ALLOWED_TIME_RESOURCE, useMutationHook as useUpdateMembershipTypeAllowedTime };
